<template>
  <div class="menu-wrapper">
    <div class="panel"
         ref="panel">
      <div class="user-panel">
        <div class="username-wrapper">
          <span class="bullet"></span>
          <span class="username"
                :title="(user && user.name) + ' ' + (user && user.surname)">{{user && user.name}} {{user && user.surname}}</span>
        </div>

      </div>
      <div class="menu-expander-wrapper">
        <div class="menu-expander"
             ref="menuExpander"
             @click.prevent="onMenuClick"></div>
      </div>
      <div class="menu-logout-wrapper"
           ref="menuLogoutWrapper">
        <div class="form__input form__input--submit logout-wrapper">
          <button type="submit"
                  @click.prevent="handleLogoutClick"
                  v-word:layout.userMenu.logout></button>
        </div>
        <div class="menu-inner">
          <div class="menu">
            <h2 v-word:layout.userMenu.userData></h2>
            <ul class="nouseredit">
              <li v-for="menuItem in menuItems.personalData"
                  :key="menuItem.id"
                  v-bind:class="activeItemId === menuItem.id ? 'active' : ''">
                <a href=""
                   @click.prevent="$emit('select', menuItem.id)"
                   v-word="menuItem.titleWord">
                  {{menuItem.title}}
                </a>
                <div v-if="menuItem.id === 'mailing_preferences'">
                  <ul>
                    <li ref="mlGerman">
                      <a href=""
                         v-word:layout.userMenu.mailingList.p7s1De
                         @click.prevent="$emit('select', 'section_ml_german')"></a>
                    </li>
                    <li ref="mlEnglish">
                      <a href=""
                         v-word:layout.userMenu.mailingList.p7s1En
                         @click.prevent="$emit('select', 'section_ml_english')">
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <div v-if="editMode">
              <!-- <h2 v-word:layout.userMenu.mailingLists></h2> -->
              <ul>
                <li ref="mlGerman">
                  <a href=""
                     v-word:layout.userMenu.mailingList.p7s1De
                     @click.prevent="$emit('select', 'section_ml_german')"></a>
                </li>
                <li ref="mlEnglish">
                  <a href=""
                     v-word:layout.userMenu.mailingList.p7s1En
                     @click.prevent="$emit('select', 'section_ml_english')">
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery';
import * as mixins from '../../mixins';
import config from 'config';
import backendConfig from '../../utils/backendConfig';

export default {
  props: ['menuItems', 'activeItemId', 'user', 'store', 'primaryLang'],
  mixins: [mixins.wordedPage],
  data() {
    return {
      menuOpened: false,
      menuLogoutWrapper: {},
      menuExpander: {},
    };
  },
  methods: {
    onMenuClick() {
      if (this.menuOpened) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    },
    openMenu() {
      const menuHeight = this.getMenuHeight();
      this.menuLogoutWrapper.css('margin-top', `-${menuHeight}px`);
      this.menuLogoutWrapper.animate({ 'margin-top': '0' }, 100);
      this.menuExpander.addClass('opened');
      this.menuOpened = true;
    },
    closeMenu() {
      const menuHeight = this.getMenuHeight();

      this.menuLogoutWrapper.animate({ 'margin-top': `-${menuHeight}px` }, 100);
      this.menuExpander.removeClass('opened');
      this.menuOpened = false;
    },
    getMenuHeight() {
      return this.menuLogoutWrapper.outerHeight();
    },
    handleLogoutClick() {
      return backendConfig.get().then(({backendUrl}) => {
        const url = backendUrl + config.backend.feeds.logout + '?sso=' + this.store.brokerData;

        return this.$http
          .put(url)
          .then(() => {
            this.$router.push({ path: 'login' });
          })
          .catch(() => {
            // TODO show user error
          });
      });
    },
    reorderMailingLists() {
      const en = this.$refs['mlEnglish'];
      const de = this.$refs['mlGerman'];

      switch (this.primaryLang) {
        case 'de':
          jQuery(de).after(en);
          break;
        case 'en':
          jQuery(en).after(de);
          break;
      }
    },
  },
  mounted() {
    this.menuLogoutWrapper = jQuery(this.$refs.menuLogoutWrapper);

    this.menuExpander = jQuery(this.$refs.menuExpander);

    jQuery(this.$refs.panel).on('click', evt => {
      evt.stopPropagation();
    });

    jQuery('body').on('click', () => {
      this.closeMenu();
    });

    this.reorderMailingLists();
  },
  watch: {
    primaryLang() {
      this.reorderMailingLists();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/user-profile/UserMenu.vue